import qs from 'qs';
import { Toast } from 'vant';
export const deleteParam = key => {
    const search = window.location.href.split('?')[1];
    let obj = {};
    const keyValuesArr = search ? search.split('&') : [];
    keyValuesArr.forEach(item => {
        const arr = item.split('=');
        if(arr[0] !== key) {
            obj[arr[0]] = decodeURIComponent(arr[1]);
        }
    });
    const idx = location.href.indexOf('?');
    const url = location.href.substring(0, idx);
    return url + '?' + qs.stringify(obj)
}

export const copyText = str => {
    const oInput = document.createElement('input');
    oInput.value = str;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display = 'none';
    Toast.success('复制成功');
    document.body.removeChild(oInput);
}


// WEBPACK FOOTER //
// ./src/utils/index.js